import { ReadRateCardDTO } from "@models/rate-card/entities/rateCard";
import { APIExtRoutes } from "@constants";

export class AnalysisRateCardListConfigs {
  static readonly DefaultRoute = APIExtRoutes.odataRateCates;

  // Table data
  static readonly PickColumns: (keyof ReadRateCardDTO)[] = [
    "id",
    "name",
    "productName",
    "subProductName",
    "platformName",
    "productAvatarUrl",
    "ownerName",
    "ownerAvatarUrl",
    "lastModifiedDate",
    "isAvailableForAnalysis",
    "isShared",
    "sharedValue",
    "status",
    "notes",
  ];

  static readonly GlobalFilterColumns: (keyof ReadRateCardDTO)[] = [
    "name",
    "ownerName",
    "productName",
    "subProductName",
    "platformName",
  ];
}
